// import React, { useEffect, useState } from "react";
// import {
//   Box, Typography, TextField, Button, Table,
//   TableHead, TableBody, TableRow, TableCell, TableContainer,
// } from "@mui/material";
// import axiosClient from "../../../configs/axios";

// const printStyles = `
//   .ch-print-header { display: none; }
//   @media print {
//     .ch-print-header { display: block !important; margin-bottom: 16px; }
//     body * { visibility: hidden; }
//     .ch-printable-area, .ch-printable-area * { visibility: visible; }
//     .ch-printable-area {
//       position: absolute; left: 0; top: 0;
//       width: 100%; overflow: visible !important;
//       height: auto !important; max-height: none !important;
//     }
//     .ch-printable-area table { border-collapse: collapse; width: 100%; }
//     .ch-printable-area th, .ch-printable-area td { border: 1px solid #ccc; padding: 6px 10px; font-size: 12px; }
//     .ch-printable-area th { background: #1C3A5E !important; color: #fff !important; -webkit-print-color-adjust: exact; }
//     .no-print { display: none !important; }
//   }
// `;

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px", fontSize: "13px", height: "38px", background: "#fafafa",
//     "& fieldset": { borderColor: "#E2E8F0" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0" },
//   },
// };

// const thSx = {
//   background: "#1C3A5E", color: "#fff", fontSize: "12px",
//   fontWeight: 600, padding: "10px 12px", whiteSpace: "nowrap"
// };

// const tdSx = { fontSize: "12px", padding: "8px 12px", color: "#2D3748" };

// const CustomerHoldingSummary = () => {
//   const [searchKey, setSearchKey] = useState("");
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const styleSheet = document.createElement("style");
//     styleSheet.type = "text/css";
//     styleSheet.innerText = printStyles;
//     document.head.appendChild(styleSheet);
//     return () => { document.head.removeChild(styleSheet); };
//   }, []);

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const res = await axiosClient.get("/cust-ledger/holding-summary", {
//         params: { searchKey: searchKey || undefined },
//       });
//       setRows(res.data || []);
//     } catch (err) {
//       console.error("Error fetching customer holding summary:", err);
//       setRows([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const handlePrint = () => { window.print(); };

//   const totals = rows.reduce(
//     (acc, r) => ({
//       current_holding: acc.current_holding + (r.current_holding || 0),
//       bucket_30_60: acc.bucket_30_60 + (r.bucket_30_60 || 0),
//       bucket_61_90: acc.bucket_61_90 + (r.bucket_61_90 || 0),
//       bucket_90_plus: acc.bucket_90_plus + (r.bucket_90_plus || 0),
//     }),
//     { current_holding: 0, bucket_30_60: 0, bucket_61_90: 0, bucket_90_plus: 0 }
//   );

//   return (
//     <Box sx={{ background: "#F4F7FB", minHeight: "100vh", padding: "20px 24px 40px" }}>

//       <Typography className="no-print" sx={{ fontSize: "16px", fontWeight: 700, color: "#1C3A5E", mb: 2.5 }}>
//         Customer Holding
//       </Typography>

//       {/* Filter card */}
//       <Box className="no-print" sx={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: "10px", p: 2.5, mb: 2.5, display: "flex", gap: 2, alignItems: "flex-end", flexWrap: "wrap" }}>
//         <Box sx={{ width: { xs: "100%", sm: 280 } }}>
//           <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6", mb: "4px" }}>
//             Search Customer
//           </Typography>
//           <TextField
//             size="small"
//             fullWidth
//             placeholder="Type customer name"
//             value={searchKey}
//             onChange={(e) => setSearchKey(e.target.value)}
//             onKeyDown={(e) => { if (e.key === "Enter") fetchData(); }}
//             sx={inputSx}
//           />
//         </Box>

//         <Button
//           onClick={fetchData}
//           disabled={loading}
//           sx={{ height: "38px", px: 3, background: "#1C3A5E", color: "#fff !important", borderRadius: "8px", fontSize: "13px", fontWeight: 600, textTransform: "none", "&:hover": { background: "#2B6CB0" } }}
//         >
//           {loading ? "Loading..." : "Show"}
//         </Button>

//         <Button
//           onClick={handlePrint}
//           sx={{ height: "38px", px: 3, background: "#2B6CB0", color: "#fff !important", borderRadius: "8px", fontSize: "13px", fontWeight: 600, textTransform: "none", "&:hover": { background: "#1C3A5E" } }}
//         >
//           🖨️ Print
//         </Button>
//       </Box>

//       {/* Report */}
//       <Box className="ch-printable-area" sx={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

//         <Box className="ch-print-header">
//           <Typography sx={{ fontSize: "18px", fontWeight: 700, textAlign: "center", color: "#1C3A5E" }}>
//             CUSTOMER HOLDING REPORT
//           </Typography>
//         </Box>

//         <TableContainer>
//           <Table size="small">
//             <TableHead>
//               <TableRow>
//                 {["Sr No", "Customer Name", "Depot", "Current Holding", "30-60 Days", "61-90 Days", "> 90 Days"].map((h) => (
//                   <TableCell key={h} sx={thSx}>{h}</TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {rows.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={7} sx={{ textAlign: "center", color: "#A0AEC0", py: 4, fontSize: "13px" }}>
//                     No records found
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 rows.map((row, idx) => (
//                   <TableRow key={row.cust_id} sx={{ background: idx % 2 === 0 ? "#fff" : "#F8FAFC" }}>
//                     <TableCell sx={tdSx}>{idx + 1}</TableCell>
//                     <TableCell sx={tdSx}>{row.customer_name}</TableCell>
//                     <TableCell sx={tdSx}>{row.depot_name}</TableCell>
//                     <TableCell sx={{ ...tdSx, fontWeight: 700 }}>{row.current_holding}</TableCell>
//                     <TableCell sx={tdSx}>{row.bucket_30_60}</TableCell>
//                     <TableCell sx={tdSx}>{row.bucket_61_90}</TableCell>
//                     <TableCell sx={{ ...tdSx, color: "#E53E3E", fontWeight: 600 }}>{row.bucket_90_plus}</TableCell>
//                   </TableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {rows.length > 0 && (
//           <Box sx={{ p: 2, borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end", gap: 4 }}>
//             <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#1C3A5E" }}>
//               Total Holding: <span style={{ color: "#2F855A" }}>{totals.current_holding}</span>
//             </Typography>
//             <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#1C3A5E" }}>
//               &gt;90 Days: <span style={{ color: "#E53E3E" }}>{totals.bucket_90_plus}</span>
//             </Typography>
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default CustomerHoldingSummary;


import React, { useEffect, useState } from "react";
import {
  Box, Typography, TextField, Button, Table,
  TableHead, TableBody, TableRow, TableCell, TableContainer,
} from "@mui/material";
import axiosClient from "../../../configs/axios";

const printStyles = `
  .ch-print-header { display: none; }
  @media print {
    .ch-print-header { display: block !important; margin-bottom: 16px; }
    body * { visibility: hidden; }
    .ch-printable-area, .ch-printable-area * { visibility: visible; }
    .ch-printable-area {
      position: absolute; left: 0; top: 0;
      width: 100%; overflow: visible !important;
      height: auto !important; max-height: none !important;
    }
    .ch-printable-area table { border-collapse: collapse; width: 100%; }
    .ch-printable-area th, .ch-printable-area td { border: 1px solid #ccc; padding: 6px 10px; font-size: 12px; }
    .ch-printable-area th { background: #1C3A5E !important; color: #fff !important; -webkit-print-color-adjust: exact; }
    .no-print { display: none !important; }
  }
`;

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px", fontSize: "13px", height: "38px", background: "#fafafa",
    "& fieldset": { borderColor: "#E2E8F0" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0" },
  },
};

const thSx = {
  background: "#1C3A5E", color: "#fff", fontSize: "12px",
  fontWeight: 600, padding: "10px 12px", whiteSpace: "nowrap"
};

const tdSx = { fontSize: "12px", padding: "8px 12px", color: "#2D3748" };

const CustomerHoldingSummary = () => {
  const [searchKey, setSearchKey] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axiosClient.get("/cust-ledger/holding-summary", {
        params: { searchKey: searchKey || undefined },
      });
      setRows(res.data || []);
    } catch (err) {
      console.error("Error fetching customer holding summary:", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchData();
    }, 400); // debounce — typing रुकने के 400ms बाद auto search
    return () => clearTimeout(delay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey]);

  const handlePrint = () => { window.print(); };

  const totals = rows.reduce(
    (acc, r) => ({
      current_holding: acc.current_holding + (r.current_holding || 0),
      bucket_30_60: acc.bucket_30_60 + (r.bucket_30_60 || 0),
      bucket_61_90: acc.bucket_61_90 + (r.bucket_61_90 || 0),
      bucket_90_plus: acc.bucket_90_plus + (r.bucket_90_plus || 0),
    }),
    { current_holding: 0, bucket_30_60: 0, bucket_61_90: 0, bucket_90_plus: 0 }
  );

  return (
    <Box sx={{ background: "#F4F7FB", minHeight: "100vh", padding: "20px 24px 40px" }}>

      <Typography className="no-print" sx={{ fontSize: "16px", fontWeight: 700, color: "#1C3A5E", mb: 2.5 }}>
        Customer Holding
      </Typography>

      {/* Filter card */}
      <Box className="no-print" sx={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: "10px", p: 2.5, mb: 2.5, display: "flex", gap: 2, alignItems: "flex-end", flexWrap: "wrap" }}>
        {/* <Box sx={{ width: { xs: "100%", sm: 280 } }}>
          <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6", mb: "4px" }}>
            Search Customer
          </Typography>
          <TextField
            size="small"
            fullWidth
            placeholder="Type customer name"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            sx={inputSx}
          />
        </Box> */}

        <Button
          onClick={handlePrint}
          sx={{ height: "38px", px: 3, background: "#2B6CB0", color: "#fff !important", borderRadius: "8px", fontSize: "13px", fontWeight: 600, textTransform: "none", "&:hover": { background: "#1C3A5E" } }}
        >
          🖨️ Print
        </Button>
      </Box>

      {/* Report */}
      <Box className="ch-printable-area" sx={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

        <Box className="ch-print-header">
          <Typography sx={{ fontSize: "18px", fontWeight: 700, textAlign: "center", color: "#1C3A5E" }}>
            CUSTOMER HOLDING REPORT
          </Typography>
        </Box>

        <TableContainer>
          <Table size="small">
            <TableHead>
             <TableRow>
  {["Sr No", "Customer Name", "Depot", "Current Holding", "30-60 Days", "61-90 Days", "> 90 Days"].map((h, i) => (
    <TableCell key={h} align={i >= 3 ? "center" : "left"} sx={thSx}>{h}</TableCell>
  ))}
</TableRow>
            </TableHead>
            <TableBody>
              {rows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} sx={{ textAlign: "center", color: "#A0AEC0", py: 4, fontSize: "13px" }}>
                    No records found
                  </TableCell>
                </TableRow>
              ) : (
               rows.map((row, idx) => (
  <TableRow key={row.cust_id} sx={{ background: idx % 2 === 0 ? "#fff" : "#F8FAFC" }}>
    <TableCell sx={tdSx}>{idx + 1}</TableCell>
    <TableCell sx={tdSx}>{row.customer_name}</TableCell>
    <TableCell sx={tdSx}>{row.depot_name}</TableCell>
    <TableCell align="center" sx={{ ...tdSx, fontWeight: 700 }}>{row.current_holding}</TableCell>
    <TableCell align="center" sx={tdSx}>{row.bucket_30_60}</TableCell>
    <TableCell align="center" sx={tdSx}>{row.bucket_61_90}</TableCell>
    <TableCell align="center" sx={{ ...tdSx, color: "#E53E3E", fontWeight: 600 }}>{row.bucket_90_plus}</TableCell>
  </TableRow>
))
              )}
             {rows.length > 0 && (
  <TableRow sx={{ background: "#EDF2F7", borderTop: "2px solid #1C3A5E" }}>
    <TableCell sx={{ ...tdSx, fontWeight: 700 }} colSpan={3}>Total</TableCell>
    <TableCell align="center" sx={{ ...tdSx, fontWeight: 700, color: "#2F855A" }}>{totals.current_holding}</TableCell>
    <TableCell align="center" sx={{ ...tdSx, fontWeight: 700 }}>{totals.bucket_30_60}</TableCell>
    <TableCell align="center" sx={{ ...tdSx, fontWeight: 700 }}>{totals.bucket_61_90}</TableCell>
    <TableCell align="center" sx={{ ...tdSx, fontWeight: 700, color: "#E53E3E" }}>{totals.bucket_90_plus}</TableCell>
  </TableRow>
)}
            </TableBody>
          </Table>
        </TableContainer>

        {/* {rows.length > 0 && (
          <Box sx={{ p: 2, borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end", gap: 4 }}>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#1C3A5E" }}>
              Total Holding: <span style={{ color: "#2F855A" }}>{totals.current_holding}</span>
            </Typography>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#1C3A5E" }}>
              &gt;90 Days: <span style={{ color: "#E53E3E" }}>{totals.bucket_90_plus}</span>
            </Typography>
          </Box>
        )} */}
      </Box>
    </Box>
  );
};

export default CustomerHoldingSummary;